import { render, staticRenderFns } from "./GPTAside.vue?vue&type=template&id=0440d0d4&scoped=true"
import script from "./GPTAside.vue?vue&type=script&lang=js"
export * from "./GPTAside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0440d0d4",
  null
  
)

export default component.exports